import isMiddleware from "@/router/middleware/isMiddleware";
import {HasPermission} from "@/utils/permisshoinHelper";
import router from "@/router";

const needle = "has_access";

export default function (to, from, next) {
    return HasAccessRoute(to) ? false : toNext(next);
}

export function HasAccessRoute(route) {
    let rule = route.meta["middleware"];
    if (!rule || !isMiddleware(needle, rule)) return true;

    let accesses = route.meta?.accesses;
    if (typeof accesses === "string") accesses = [accesses];
    const accesses_every = route.meta?.accesses_every;

    if (!Array.isArray(accesses) || !accesses.length) return true;

    return accesses_every ? accesses.every(HasPermission) : accesses.some(HasPermission)
}

const toNext = (next) => {
    const availableTo = router.getRoutes().filter(i => i.meta?.accesses_redirect && HasAccessRoute(i));
    if (!availableTo.length) {
        return next({name: "403"});
    }
    return next({name: availableTo[0].name})
}
